import ViewUserRoleDetailsLayout from "./ViewUserRoleDetailsLayout";

export default ViewUserRoleDetailsLayout;
